/*
 * @Author       : 程哲林
 * @Date         : 2022-01-14 15:48:48
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-21 14:15:42
 * @FilePath     : /marketing-introduce-ssr/services/index.ts
 * @Description  : 未添加文件描述
 */

import session from '@woulsl/storage/session';
import { rq } from 'utils/request';

import { RECORD_KEY, TINMAN_BASE_C_URL } from '../common/const';

export async function getWxConfig<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/api/product/open/wxmp/create-signature',
    prefix: '/mall/product',
    baseURL: TINMAN_BASE_C_URL,
    params
  });
}

export async function userActionRecord(params = {}, isOpen = false) {
  try {
    const data = session.get(RECORD_KEY);

    if (!data) {
      session.set(RECORD_KEY, params);
    }

    await rq({
      url: 'action/userActionRecord',
      method: 'POST',
      authPlatform: isOpen ? [] : ['jojoApp', 'miniApp', 'wx'],
      authPrefix: '/fe/',
      prefix: '/open/',
      data: {
        ...data,
        sceneType: __store?.actInfo?.activityType,
        ...params
      },
      baseURL: `${TINMAN_BASE_C_URL}/api/gravity`,
      // 该接口不做登录拦截
      enforcement: true
    });
  } catch (e) {
    console.error(e);
  }
}

export async function getRetainRule<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'activity/getRetainPopup',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/fe/',
    prefix: '/open/',
    params
  });
}

export async function scanCodeSaveOpenId<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'event/scanCodeSaveOpenId',
    prefix: '/open/',
    data: params,
    method: 'POST'
  });
}
export async function scanActivityCode<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'event/scanActivityCode',
    prefix: '/fe/',
    data: params,
    method: 'POST'
  });
}

export async function getWxSchemaUrl<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'wechatMiniProgram/getSchemaUrl',
    data: params,
    prefix: '/mall/cashback/noRight/',
    baseURL: TINMAN_BASE_C_URL,
    method: 'POST'
  });
}

// 邀请明细接口
export interface CashBonusRecord {
  title: string;
  inviteeUserPhoneNoMask: string;
  amount: number;
  createTime: number;
  withdrawableFlag: boolean;
  withdrawableTips?: string;
}

export interface CashBonusRecordsResponse {
  pageCount: string;
  pageRecords: CashBonusRecord[];
  pageSize: string;
  totalCount: string;
  pageNum: string;
}

export async function getCashBonusRecords<T = CashBonusRecordsResponse>(params?: {
  pageNum?: number;
  pageSize?: number;
  source?: string;
}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'user/cash-prizes',
    method: 'GET',
    params
  });
}

// 发放明细接口
export interface WithdrawRecord {
  withdrawNo: string; // 提现业务单号
  amount: number; // 提现申请金额，单位：元
  totalTaxAmount: number; // 总税金额，元
  createTime: number; // 创建时间，毫秒级时间戳
  status: 'PROCESSING' | 'SUCCESS' | 'FAILED'; // 提现状态
  failReason?: string; // 失败原因
}

export interface WithdrawRecordsResponse {
  pageCount: string;
  pageRecords: WithdrawRecord[];
  pageSize: string;
  totalCount: string;
  pageNum: string;
}

export async function getWithdrawRecords<T = WithdrawRecordsResponse>(params?: {
  pageNum?: number;
  pageSize?: number;
  status?: string;
  bizType?: string;
}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'user/yunzhanghu/withdraws',
    method: 'GET',
    params,
    authPlatform: ['jojoApp', 'miniApp', 'wx']
  });
}

export async function getWechatWithdrawRecords<T = WithdrawRecordsResponse>(params?: {
  pageNum?: number;
  pageSize?: number;
  status?: string;
  bizType?: string;
}): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'user/wechat/withdraws',
    method: 'GET',
    params,
    authPlatform: ['jojoApp', 'miniApp', 'wx']
  });
}
